






import { Vue } from "@/app"
import InvestmentList from '@/modules/investments/components/InvestmentList.vue'

export default Vue.extend({
  name: "InvestmentsAllocationDetail",
  components: {
    InvestmentList,
  },
  beforeRouteEnter(to, from, next) {
    return [
      "current",
      "buyback",
      "in_grace",
      "defaulted",
      "overdue_15",
      "overdue_16_30",
      "overdue_31_60",
      "overdue_60",
      "in_recovery",
    ].includes(to.params.id)
      ? next()
      : next("/")
  },
  props: {
    id: { type: String, required: true },
  },
  data() {
    return {
      loading: false,
      page: 1,
      size: 10,
      count: 0,
      items: [],
    }
  },
  computed: {
    titles() {
      return {
        current:       this.$t("investmentsAllocationDetailPage.current"),
        buyback:       this.$t("investmentsAllocationDetailPage.buyback"),
        in_grace:      this.$t("investmentsAllocationDetailPage.gracePeriod"),
        defaulted:     this.$t("investmentsAllocationDetailPage.default"),
        overdue_15:    this.$t("investmentsAllocationDetailPage.overdue_15"),
        overdue_16_30: this.$t("investmentsAllocationDetailPage.overdue_16_30"),
        overdue_31_60: this.$t("investmentsAllocationDetailPage.overdue_31_60"),
        overdue_60:    this.$t("investmentsAllocationDetailPage.overdue_60"),
        in_recovery:   this.$t("investmentsAllocationDetailPage.inRecovery"),
      }
    },
    title() {
      return this.titles[this.id] || this.$t("investmentsAllocationDetailPage.investmentsAllocation")
    },
    accountId() {
      return this.$store.state.account.id
    },
  },
  watch: {
    page() { this.getItems(); this.$vuetify.goTo(this.$refs.investmentList) },
    size() { this.getItems() },
    accountId() {
      this.getItems()
    },
  },
  mounted() {
    this.getItems()
  },
  methods: {
    getItems() {
      if (this.accountId) {
        this.loading = true
        this.$http
          .get(`/dashboard/${this.accountId}/investments/${this.id}/`, { params: {
            page: this.page, size: this.size,
          }})
          .then((investments) => {
            this.loading = false
            this.count = investments.data.count
            this.items = investments.data.results
          })
          .catch(() => {
            this.loading = false
          })
      }
    },
  },
})
